import { render, staticRenderFns } from "./fireFightingCheckDetail.vue?vue&type=template&id=37a2b687"
import script from "./fireFightingCheckDetail.vue?vue&type=script&lang=js"
export * from "./fireFightingCheckDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a2b687')) {
      api.createRecord('37a2b687', component.options)
    } else {
      api.reload('37a2b687', component.options)
    }
    module.hot.accept("./fireFightingCheckDetail.vue?vue&type=template&id=37a2b687", function () {
      api.rerender('37a2b687', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/fft/fireFightingCheckDetail.vue"
export default component.exports